module.exports = __webpack_public_path__ + "static/media/CERAMIC_DISC_CORE.5548b571.png";